import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import pick from 'lodash/pick';
import { getSuffix } from '../../../../lib/apiKeys';
import a from '../../../../redux/actions';
import s from '../../../../redux/selectors';
import types from '../../../../types';

const InlineSelect = ({
  selectProps,
  inputValue,
  apiKey,
  onChange,
  updateNumericInput,
  options,
  ariaLabel,
}) => {
  const effectiveOnChange = apiKey === null ?
    e => onChange(e.target.value) :
    e => updateNumericInput({ [getSuffix(apiKey)]: e.target.value }, 'input_takeaction');
  const className = `${selectProps.className || ''} action-details__inline-select`;
  return (
    <select
      {...selectProps}
      aria-label={ariaLabel || apiKey}
      className={className}
      value={inputValue.input}
      onChange={effectiveOnChange}
    >
      {options.map(option => (
        <option value={option.value} key={option.value}>{option.display}</option>
      ))}
    </select>
  );
};

InlineSelect.propTypes = {
  // ownProps
  apiKey: PropTypes.string,
  selectProps: PropTypes.shape({}),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    display: PropTypes.string.isRequired,
  })).isRequired,
  ariaLabel: PropTypes.string,
  // connected props
  inputValue: types.UserInput.isRequired,
  updateNumericInput: PropTypes.func.isRequired,
  onChange: PropTypes.func,
};

InlineSelect.defaultProps = {
  selectProps: {},
  onChange: null,
  apiKey: null,
  ariaLabel: '',
};

const mapStateToProps = (state, ownProps) => [
  'inputValue',
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps),
}), {});

const mapDispatchToProps = dispatch => bindActionCreators(
  pick(a, [
    'updateNumericInput',
  ]),
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(InlineSelect);
